import Comm from "../../../Comm"

type CommandBody = { msg_type: number, [key: string]: unknown }

// The websocket service only answers the latest outstanding request per charger: send two at once and
// the earlier one times out with a 404 after ~10 s (measured 2026-09-23). So every command these screens
// send waits for the previous one to the same charger, as the rest of the app awaits its calls in turn.
const queues = new Map<string, Promise<unknown>>()

async function send<T>(chargerId: string, body: CommandBody, silent: boolean): Promise<T> {
  const response = await Comm('/api-websocket/mobile', {
    method: 'POST',
    headers: { 'Charger_id': chargerId, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }, silent)
  if (!response.ok) throw new Error(`msg_type ${body.msg_type} answered ${response.status}`)
  return await response.json()
}

// One round trip to the charger through the websocket service, the channel the mobile apps use when
// they reach a charger remotely. Resolves to the charger's JSON reply (VLT-2695). silent skips the admin
// error toast, for polling that reports a failure itself.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sendChargerCommand<T = any>(chargerId: string, body: CommandBody, silent = false): Promise<T> {
  const run = (queues.get(chargerId) ?? Promise.resolve()).then(() => send<T>(chargerId, body, silent))
  queues.set(chargerId, run.catch(() => undefined))
  return run
}

// RSP_GENERAL err_code values the screens act on; 11 is a success that takes effect after a restart.
export const ERR_OK = 0
export const ERR_OK_RESTART_NEEDED = 11
export const ERR_NOT_SUPPORTED = 24

export function isGeneralOk(reply: { err_code?: number } | null | undefined): boolean {
  return reply?.err_code === ERR_OK || reply?.err_code === ERR_OK_RESTART_NEEDED
}
